import { Outlet } from "react-router-dom";
import Header from "../components/header/header";
import Footer from "../components/footer/footer";
import { useEffect } from "react";
const Layout = () => {
  useEffect(() => {
    document.documentElement.classList.remove("dark");
  }, []);
  return (
    <div className="bg-[#F9F8FE]">
      <Header />
      <Outlet />
      <Footer />
    </div>
  );
};

export default Layout;
